<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="msg-view">
                        <p>{{ text }}</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>                       
                    </div>                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.msg-modal{
    width: 585px;
    background-color: #fcfbfa;
    border: 3px solid #fff;
    font-size: 24px;
    color: #525b65;
    z-index: 1001;
    box-sizing: border-box;

    .dialog-content{
        margin: 4px;
        border: 1px solid #e7e1ce;
    }
    
    .title{
        width: 81px;
        height: 32px;
        margin: 14px auto 20px;
        background-image: url(~@/assets/images/modal/title-msg.png);
    }
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    /* width: 666px;
    height: 137px;
    margin: 20px auto;
    background-image: url(~@/assets/images/bg-msg.png);
    color: #8e492e; */
}

.msg-view p{
    padding: 38px 36px 130px;
    line-height: 1.8;
    // text-align: center;
    font-size: 24px;
    color: #917945;    
}

.u-ctrl{
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 34px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 110px;
}

.u-ctrl .u-btn.ok{
        width: 286px;
        height: 79px;
        margin: 5px auto 0;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            type : 'success-gacha',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>